module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--error"
  }, [_c('div', {
    staticClass: "group group--sidebar group--last group--df-column group--flex"
  }, [_c('h1', {
    staticClass: "p",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p mb0"
  }, [_vm._v("We can help you by phone:")]), _vm._v(" "), _c('a', {
    staticClass: "tdn",
    attrs: {
      "href": ("tel:" + _vm.number)
    }
  }, [_c('h2', {
    staticClass: "h1 mt0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.number))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('module-button', {
    staticClass: "mw220",
    attrs: {
      "button": "primary",
      "link": _vm.link
    }
  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p"
  }, [_vm._v("A Carelon team member is available "), _c('br'), _vm._v("24 hours a day, 7 days a week.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22af4006"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/base/Error.vue
// module id = 407
// module chunks = 0